import { render } from "./GoodsSize.vue?vue&type=template&id=52370650&scoped=true"
import script from "./GoodsSize.vue?vue&type=script&lang=js"
export * from "./GoodsSize.vue?vue&type=script&lang=js"

import "./GoodsSize.vue?vue&type=style&index=0&id=52370650&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52370650"]])

export default __exports__